module.exports = __webpack_public_path__ + "static/HSL-LED-Street-Light-db097bbaec80f6d0b4c6f0b20ed70877.jpg";